<template>
  <div class="flex flex-col md:flex-row justify-between mx-auto items-center md:w-5/6 w-full">
    <div class="w-auto flex relative mr-16">
      <select v-model="newHarp" class="outline-none appearance-none shadow-md rounded-md p-2">
        <option value="Choose harp" class="uppercase">{{ $t('userData.chooseHarp') }}</option>
        <option v-show="harp" v-for="harp in harps" :key="harp.id" :value="harp">{{ harp.description }}</option>
      </select>
      <div class="flex items-center">
        <dropdown-arrow class="pointer-events-none right-1 absolute" />
      </div>

    </div>
    <div class="w-full flex justify-between items-center mt-5 md:mt-0">
      <button class="p-2 px-6 rounded-md shadow-md hover:bg-b2c-red-300 hover:text-white mr-4" @click="addYourHarp">{{$t('userData.save')}} </button>
      <button class="p-2 px-6 rounded-md shadow-md hover:bg-b2c-red-300 hover:text-white " @click="$emit('not-added')">{{$t('userData.cancel')}} </button>
    </div>
  </div>
</template>

<script>
import { addNewHarp } from '@/services/HarpsService';
import { mapGetters, mapActions } from 'vuex';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';

export default {
  props: ['harps'],

  data() {
    return {
      newHarp: 'Choose harp',
    };
  },

  components: {
    DropdownArrow,
  },

  computed: {
    ...mapGetters({
      customer: 'auth/customer',
    }),
  },

  methods: {
    ...mapActions({
      updatedHarps: 'notification/updatedHarps',
    }),

    addYourHarp() {
      if (this.newHarp === 'Choose harp') {
        this.createNotification('error', `${this.$t('notifications.chooseHarp')}`);
        return;
      }
      addNewHarp(this.newHarp, this.customer.id).then(() => {
        this.newHarp = 'Choose harp';
        this.updatedHarps(true);
        this.$emit('added-harp');
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },
  },
};
</script>
